import { InjectionToken } from '@angular/core';
import { ErrorTranslationConfig } from '../models/error-translation.model';

/**
 * Injection token for providing error translation configurations.
 * Supports multi-provider pattern to allow multiple layers of translations.
 */
export const ERROR_TRANSLATION_CONFIG =
  new InjectionToken<ErrorTranslationConfig>('ERROR_TRANSLATION_CONFIG');
